import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    timeout: 15000,
});

// Public site URL (for canonical URLs etc.).
// Prefer REACT_APP_SITE_URL build-time override; never hardcodes a preview URL.
export const SITE_URL = process.env.REACT_APP_SITE_URL || '';

// Token interceptor for admin routes
let authToken = null;

export const setAuthToken = (token) => {
    authToken = token;
    if (token) {
        localStorage.setItem('sk_admin_token', token);
    } else {
        localStorage.removeItem('sk_admin_token');
    }
};

export const getAuthToken = () => {
    if (authToken) return authToken;
    authToken = localStorage.getItem('sk_admin_token');
    return authToken;
};

api.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token && (config.url || '').includes('/admin')) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (token && (config.url || '').includes('/auth/')) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401 && (err.config?.url || '').includes('/admin')) {
            setAuthToken(null);
            if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/admin/login')) {
                window.location.href = '/admin/login';
            }
        }
        return Promise.reject(err);
    }
);

export const BACKEND = BACKEND_URL;
